import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import VoiceChatIcon from "@mui/icons-material/VoiceChat";
import PaymentIcon from "@mui/icons-material/Payment";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NavigateNextIcon from "@mui/icons-material/NavigateNext"; // Import NavigateNextIcon
import Profile from "../Profile/Profile";
import TimeSlots from "../TimeSlots/TimeSlots";
import ComingSoon from "../../../Pages/ComingSoon/ComingSoon";
import { HiOutlinePuzzle } from 'react-icons/hi';
import { getRole } from "../../../DecodeToken/DecodeToken";
import { contestResult } from "../../../ApiServices/ApiServices";
import { handleError } from "../../../Utils";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ChatIcon from '@mui/icons-material/Chat';

function Sidebar() {
  const [isVisibleProfile, setIsVisibleProfile] = useState(false);
  const [isVisibleTimeSlots, setIsVisibleTimeSlots] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isVisibleComingSoon, setIsVisibleComingSoon] = useState(false);
  const role = getRole();

  const toggleProfileModal = () => {
    setIsVisibleProfile(!isVisibleProfile);
    // setIsSidebarVisible(!isSidebarVisible);
  };

  const toggleTimeSlotsModal = () => {
    setIsVisibleTimeSlots(!isVisibleTimeSlots);
    // setIsSidebarVisible(!isSidebarVisible);
  };

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

   const [contestData, setContestData] = useState(null);

    const fetchContestResult = async()=>{
        try {
            const result = await contestResult();
            setContestData(result?.data);
        } catch (error) {
            return handleError(error?.response?.data?.message);
        }
    }

    useEffect(()=>{
        fetchContestResult();
    },[])


  return (
    // for user(mentee) below options will not be visible
    //    profile
    //    sessions
    //    time slots
    //    priority DM
    //    Payments
    //    What's new

    <div className="relative min-h-[90vh]">
      {/* Mobile Hamburger Button with NavigateNextIcon */}
      <button
        className=" text-black rounded-md bg-white shadow-lg z-50 lg:hidden"
        onClick={toggleSidebar}
      >
        <NavigateNextIcon className="text-black" />
      </button>

      {/* Sidebar */}
      <aside
        className={`${
          isSidebarVisible ? "block" : "hidden"
        } lg:block sidebar bg-gray-100 h-full shadow-lg sm:w-36 lg:w-48 px-4   top-0 left-0 bottom-0 z-50 overflow-y-auto sm:relative`}
      >
        <nav>
          <ul className="space-y-4">
            <NavLink
              to="home"
              className="flex items-center text-gray-700 hover:text-blue-600 text-lg"
              onClick={toggleSidebar}
            >
              <HomeIcon className="mr-2" /> <span>Home</span>
            </NavLink>

            <NavLink
              to="bookings"
              className="flex items-center text-gray-700 hover:text-blue-600 text-lg"
              onClick={toggleSidebar}
            >
              <WifiCalling3Icon className="mr-2" /> <span>Bookings</span>
            </NavLink>

            {role === "mentor" && (
              <NavLink
                to="prioritydm"
                className="flex items-center text-gray-700 hover:text-blue-600 text-lg cursor-pointer"
                onClick={toggleSidebar}
                // onClick={setIsVisibleComingSoon}
              >
                <ChatIcon className="mr-2" /> <span>Priority DM</span>
              </NavLink>
            )}
            
            {role === "mentor" && (
              <NavLink
                to="referral"
                className="flex items-center text-gray-700 hover:text-blue-600 text-lg cursor-pointer"
                onClick={toggleSidebar}
                // onClick={setIsVisibleComingSoon}
              >
                <PersonAddIcon className="mr-2" /> <span>Referral</span>
              </NavLink>
            )}

            {/* Profile link - hidden for user role */}
            {role === "mentor" && (
              <li
                onClick={toggleProfileModal}
                className={`flex items-center text-gray-700 hover:text-blue-600 cursor-pointer text-lg`}
              >
                <AccountCircleIcon className="mr-2" /> <span>Profile</span>
              </li>
            )}

            <NavLink
              to="account"
              className="flex items-center text-gray-700 hover:text-blue-600 text-lg"
              onClick={toggleSidebar}
            >
              <AccountBalanceIcon className="mr-2" /> <span>Account</span>
            </NavLink>

            {/* Sessions - hidden for user role */}
            {role === "mentor" && (
              <NavLink
                to="sessions"
                className={`flex items-center text-gray-700 hover:text-blue-600 text-lg`}
                onClick={toggleSidebar}
              >
                <MenuBookIcon className="mr-2" /> <span>Sessions</span>
              </NavLink>
            )}

            {/* Time Slots - hidden for user role */}
            {role === "mentor" && (
              <li
                onClick={toggleTimeSlotsModal}
                className={`flex items-center text-gray-700 hover:text-blue-600 cursor-pointer text-lg`}
              >
                <AccessTimeIcon className="mr-2" /> <span>Time Slots</span>
              </li>
            )}

            {/* Payment - hidden for user role */}
            {role === "mentor" && (
              <NavLink
                to="payments"
                className="flex items-center text-gray-700 hover:text-blue-600 text-lg"
                onClick={toggleSidebar}
              >
                <PaymentIcon className="mr-2" /> <span>Payments</span>
              </NavLink>
            )}

            <NavLink
              to="rewards"
              className="flex items-center text-gray-700 hover:text-blue-600 cursor-pointer text-lg"
              onClick={toggleSidebar}
            >
              <CardGiftcardIcon className="mr-2" /> <span>Rewards</span>
            </NavLink>

            {/* What's New - hidden for user role */}
            {role === "mentor" && (
              <li
                className={`flex items-center text-gray-700 hover:text-blue-600 cursor-pointer text-lg ${
                  role === "user" ? "hidden" : ""
                }`}
                onClick={toggleSidebar}
              >
                <NotificationsNoneIcon className="mr-2" />{" "}
                <span onClick={setIsVisibleComingSoon}>What's New</span>
              </li>
            )}

            {contestData && <NavLink
              to="contest"
              className="flex items-center text-gray-700 hover:text-blue-600 cursor-pointer text-lg"
              onClick={toggleSidebar}
            >
              <HiOutlinePuzzle className="mr-2" /> <span>Contest</span>
            </NavLink>}
          </ul>
        </nav>

        {/* Profile Modal */}
        {isVisibleProfile && (
          <Profile
            isVisible={isVisibleProfile}
            setIsVisible={setIsVisibleProfile}
          />
        )}

        {/* Time Slots Modal */}
        {isVisibleTimeSlots && (
          <TimeSlots
            isVisible={isVisibleTimeSlots}
            setIsVisible={setIsVisibleTimeSlots}
          />
        )}
        <ComingSoon isVisible={isVisibleComingSoon} setIsVisible={setIsVisibleComingSoon}/>
      </aside>
    </div>
  );
}

export default Sidebar;
